// Este componente esta siendo migrado al nuevo repositorio de https://github.com/melisource/fury_vpp-frontend-components, no modificar, ante cualquier duda mandar mensaje a Mcalderon

import Iframe from './iframe';

export default Iframe;
